import angular from 'angular';

class errorModalCtrl {
    /* @ngInject */
    constructor() {}
    $onInit() {
        this.modalMessage = angular.copy(this.resolve.modalMessage);
    }

    close() {
        this.modalInstance.dismiss('cancel');
    }
}

angular.module('app.principal').component('errorModal', {
    templateUrl: require('./modal-error.html'),
    controller: errorModalCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
    },
});
